import { DataTableSearch } from '@/common/ui/table/data-table-search'
import { DataTableResetFilter } from '@/common/ui/table/data-table-reset-filter'
import { DataTableFilterSelector } from '@/common/ui/table/data-table-filter-selector'
import { GetRegisteredPlayerTableData } from '@/modules/manage-player/type'
import { columns } from './constants'
import { DataTableArrow } from '@/common/ui/table/data-table-arrow'
import useQueryGetChannels from '@/modules/manage-player/api/hooks/useQueryGetChannels'
import { useTablePagination } from '@/common/hooks/useTablePaginate'
import { useMemo } from 'react'
import { Checkbox } from '@/common/ui/checkbox'
import { useQueryState, parseAsBoolean } from 'nuqs'

type SortOrder = 'asc' | 'desc' | undefined

interface RegisteredPlayerTableProps {
	data: GetRegisteredPlayerTableData[]
	total: number
	isLoading?: boolean
	onSort?: (columnId: string, order: SortOrder) => void
}

export default function RegisteredPlayerTable({
	data,
	total,
	isLoading,
	onSort,
}: RegisteredPlayerTableProps) {
	const { data: channelsData } = useQueryGetChannels({
		skip: 0,
		take: 100,
		isActive: true,
	})
	const { setChannelFilter } = useTablePagination()
	const [hasDeposit, setHasDeposit] = useQueryState(
		'hasDeposit',
		parseAsBoolean.withDefault(false),
	)

	const channelOptions = useMemo(
		() =>
			channelsData?.data.map((channel) => ({
				label: channel.name,
				value: channel.name,
			})) || [],
		[channelsData],
	)

	return (
		<div className="space-y-4">
			<div className="flex flex-wrap items-center gap-4">
				<DataTableSearch
					placeHolder="ค้นหา..."
					searchHint="สามารถค้นหาด้วย: เบอร์โทร, IP Address, บัญชีธนาคาร, เลขบัญชี"
				/>
				<DataTableResetFilter />
				<DataTableFilterSelector
					options={channelOptions}
					placeholder="เลือกช่องทาง"
					label="ช่องทาง"
					onValueChange={setChannelFilter}
				/>
				<div className="flex items-center gap-2">
					<Checkbox
						id="hasDeposit"
						checked={hasDeposit}
						onCheckedChange={(checked) => setHasDeposit(checked ? true : null)}
					/>
					<label htmlFor="hasDeposit" className="cursor-pointer text-sm">
						มียอดฝากเท่านั้น
					</label>
				</div>
			</div>
			<DataTableArrow
				columns={columns}
				data={data}
				total={total}
				isLoading={isLoading}
				onSort={onSort}
			/>
		</div>
	)
}
